export default "__VITE_ASSET__DA_2m0Fr__"